/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NotificationEventType } from './NotificationEventType';
import {
    NotificationEventTypeFromJSON,
    NotificationEventTypeFromJSONTyped,
    NotificationEventTypeToJSON,
} from './NotificationEventType';

/**
 * 
 * @export
 * @interface CreateEventTopicRouteRequest
 */
export interface CreateEventTopicRouteRequest {
    /**
     * 
     * @type {NotificationEventType}
     * @memberof CreateEventTopicRouteRequest
     */
    eventType: NotificationEventType;
    /**
     * The ID of the topic to route events to.
     * @type {string}
     * @memberof CreateEventTopicRouteRequest
     */
    topicId: string;
}

/**
 * Check if a given object implements the CreateEventTopicRouteRequest interface.
 */
export function instanceOfCreateEventTopicRouteRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "eventType" in value;
    isInstance = isInstance && "topicId" in value;

    return isInstance;
}

export function CreateEventTopicRouteRequestFromJSON(json: any): CreateEventTopicRouteRequest {
    return CreateEventTopicRouteRequestFromJSONTyped(json, false);
}

export function CreateEventTopicRouteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEventTopicRouteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eventType': NotificationEventTypeFromJSON(json['eventType']),
        'topicId': json['topicId'],
    };
}

export function CreateEventTopicRouteRequestToJSON(value?: CreateEventTopicRouteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'eventType': NotificationEventTypeToJSON(value.eventType),
        'topicId': value.topicId,
    };
}

